import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconListAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconListAdd"><Path d="M3.5 5.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 11.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 17.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M13.5 14.5L21.5 14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 10.5V18.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconListAdd;
